import i18n from "@/i18n";
const { t } = i18n.global;

let model = {};

model.tableRules = {
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "service_name",
  defaultSort: ["service_name", "ascending"],
  fields:
    "service_id,service_name,service_general,iden_type,main_group_id,create_by,home_page,icon_display,description,permit_edit,permit_delete,is_priority",
  filters: "",
  dataSearch: {
    value: {
      service_name: "",
      home_page: "",
      create_by: "",
      is_priority: "",
      main_group_id: "",
    },
    operator: {
      service_name: ":regex_i:",
      home_page: ":regex_i:",
      create_by: "",
      is_priority: "",
      main_group_id: "",
    },
  },
};

model.form = {
  id: null,
  service_name: "",
  service_general: "",
  iden_type: "dpi",
  main_group_id: null,
  home_page: "",
  icon_display: "",
  description: "",
  is_priority: 0,
};

model.rules = {
  service_name: [
    { required: true, message: () => t("t_validate_service_name_required"), trigger: "blur" },
  ],
  icon_display: [
    {
      validator: (_rule, value, callback) => {
        if (!value) {
          callback();
        } else if (/^(https?:\/\/|\/)/.test(value)) {
          callback();
        } else {
          callback(new Error(t("t_validate_icon_display_format")));
        }
      },
      trigger: "blur",
    },
  ],
};

export default model;
